export default __webpack_public_path__ + "static/media/customer-icon.a79611cf.png";